<script setup lang="ts">
import { computed } from 'vue'
import { apps, formatting } from '@hantera/portal-app'
import AppSlotView from '@/AppSlotView.vue'

const { country } = formatting

const props = defineProps<{
  channelKey: string
  countryCode: string
  data: Record<string, any>
  canWrite: boolean
}>()

const emit = defineEmits<{
  (e: 'remove', countryCode: string): void
  (e: 'setField', countryCode: string, field: string, value: any): void
  (e: 'removeField', countryCode: string, field: string): void
}>()

const countryName = computed(() => {
  return country(props.countryCode) || props.countryCode
})

function handleSetField(field: string, value: any) {
  emit('setField', props.countryCode, field, value)
}

function handleRemoveField(field: string) {
  emit('removeField', props.countryCode, field)
}
</script>

<template>
  <div class="country-row">
    <div class="country-row__info">
      <span :class="`fi fi-${countryCode.toLowerCase()}`"></span>
      <span class="country-row__name">{{ countryName }}</span>
      <span class="country-row__code">{{ countryCode }}</span>
    </div>

    <div class="country-row__slots">
      <AppSlotView
        :slot="apps.channelEditorSlots.country.editor"
        :context="{
          channelKey: channelKey,
          countryCode: countryCode,
          data: data,
          setField: handleSetField,
          removeField: handleRemoveField,
        }"
      />
    </div>

    <button
      v-if="canWrite"
      class="btn-danger"
      @click="emit('remove', countryCode)"
      title="Remove country"
    >×</button>
  </div>
</template>

<style scoped>
.country-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid hsl(var(--color-80));
}

.country-row:last-child {
  border-bottom: none;
}

.country-row__info {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 160px;
}

.country-row__name {
  font-size: 0.875rem;
}

.country-row__code {
  font-size: 0.75rem;
  color: hsl(var(--color-40));
  font-family: monospace;
}

.country-row__slots {
  flex: 1;
}
</style>
